import React, { useContext } from "react";
import {
	ResultsTournamentContext,
	ResultsMenuStoreContext,
} from "@state/context/results";

export default function SelectedTournamentsHeaderButton() {
	const resultsMenuStore = useContext(ResultsMenuStoreContext);
	const tournament = useContext(ResultsTournamentContext);

	return (
		<th className="table--results__header__data u-type--right">
			<button
				className="btn btn--square btn--square--xsml btn--ghost"
				onClick={() => resultsMenuStore.removeTournament(tournament.id)}
			>
				<i className="u-icon u-icon--sml u-icon--remove u-color--core--snow" />
			</button>
		</th>
	);
}
